/**
 * Created by Christof Sander on 27.09.2016.
 */

const utils = require('frontend-controller/lib/utils')

module.exports = {
	extends: [
		'/',
		'templates',
		'userTrees',
		'userTrees'
	],

	actions: {
		addTree: {
			source: {
				load: {
					componentData: {
						config: {
							lastMileSelector: 'section.filterContent section.colWrap',
						}
					}
				}
			}
		}
	},

	methods: {
		// TODO: DOC!
		onTreeAction: function (data) {
			var self = this;

			switch (data.onTreeActionOptions.eventType) {
				// 		case 'ready.jstree':
				// 			break;
				//
				case 'select_node.jstree':
					if(!data.onTreeActionOptions.autoSelect || (this.config.decisionOptions && this.config.decisionOptions.decideOnAutoSelect)) {
						// TODO: impl. animation and animation-delay
						// show page actions if necessary
						this.parentComponents(undefined, function (parentComponent) {
							if (utils.isFunction(parentComponent.hooks.onDecision)) {
								parentComponent.trigger('onDecision', {
									decisionComponent: self,
									decisionType: 'submit',
									decisionOptions: self.config.decisionOptions || {},
									data: data.onTreeActionOptions.nodeData
								});
								return false;
							}
						});
					}
					// this.$.find('.templates_atomTrees_actionsForm').show();
					break;

				// case 'deselect_node.jstree':
					// hide page actions if necessary
					// this.$.find('.templates_atomTrees_actionsForm').hide();
					// break;
			}
		}
	},

	// NOTE: prevent userTrees handlers from being called for this selectUserTrees-Component
	handlers: undefined
};
